import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    contractors: '',
    loading: false,
    error: null
  },
  mutations: {
    SET_CONTRACTORS(state, data) {
      state.contractors = data
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async getContractorsCount({ commit, dispatch }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const [bankless, emailless, onHold] = await Promise.all([
          dispatch('getContractorsBankless'),
          dispatch('getContractorsEmailless'),
          dispatch('getContractorsOnHold')
        ])

        commit('SET_CONTRACTORS', {
          bankless: bankless.data,
          emailless: emailless.data,
          onHold: onHold.data,
        })

        return {
          bankless: bankless.data,
          emailless: emailless.data,
          onHold: onHold.data,
        }
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async getContractorsBankless({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/contractors/bankless/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getContractorsEmailless({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/contractors/emailless/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getContractorsOnHold({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/contractors/onHold/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    }
  }
}